import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import { Button } from '../../../ui/Button';
import { MessageIcon, PhoneIcon } from '../../../ui/icons';
import { useContactFormAction } from '../ContactForm/useContactFormAction';
import { callButtonWrapper, footerActions, messageButtonWrapper } from './propertyManagerModule.styles';

export const PropertyManagerFooter = () => {
  const { openContactForm, contactFormOverlay } = useContactFormAction();
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const contactPhone = listing?.listedBy?.contactPhone;

  if (!listing || listing.active === false) return null;

  const handleCall = () => {
    if (contactPhone) {
      window.location.href = `tel:${contactPhone.replace(/\D/g, '')}`;
    }
  };

  return (
    <div className={footerActions}>
      <div className={messageButtonWrapper}>
        <Button
          shape="rectangle"
          tone="brand"
          emphasis="filled"
          fluid={true}
          icon={<MessageIcon />}
          onClick={openContactForm}
        >
          Message
        </Button>
      </div>
      {contactPhone && (
        <div className={callButtonWrapper}>
          <Button
            shape="rectangle"
            tone="brand"
            emphasis="outlined"
            fluid={true}
            icon={<PhoneIcon />}
            onClick={handleCall}
          >
            Call
          </Button>
        </div>
      )}
      {contactFormOverlay}
    </div>
  );
};
